import styled, { css } from "styled-components";

export const SpectralNestedBoxStyle = css`
  background: #f9f9ff;
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.04);
  border: 1px solid #e6ecf3;
  border-radius: 12px;
  padding: 20px;
`;

export const SpectralNestedBox = styled.div`
  ${SpectralNestedBoxStyle}
`;

export default SpectralNestedBox;
